import {
  validateCompleteName,
  validatePhone,
} from "./validate.js";
import debounce from "./debounce.js";

export default class BasicForm {
  constructor(formSelector) {
    this.errorTypes = [
      "valueMissing",
      "typeMismatch",
      "customError",
      "patternMismatch",
      "tooShort",
    ];

    this.errorMessages = {
      fullName: {
        valueMissing: "O campo de nome não pode estar vazio.",
        patternMismatch: "Por favor, preencha um nome válido.",
        tooShort: "Por favor, preencha um nome válido.",
      },
      email: {
        valueMissing: "O campo de e-mail não pode estar vazio.",
        typeMismatch: "Por favor, preencha um email válido.",
        tooShort: "Por favor, preencha um email válido.",
      },
      phone: {
        valueMissing: "O campo de telefone não pode estar vazio.",
        patternMismatch: "Digite um número de telefone válido.",
        tooShort: "O campo de celular não tem dígitos suficientes.",
      },
      companyName: {
        valueMissing: "O campo de empresa não pode estar vazio.",
        patternMismatch: "Por favor, preencha um nome válido.",
        tooShort: "Por favor, preencha um nome válido.",
      },
      coverage: {
        valueMissing: "Selecione qual a cobertura que você está buscando.",
      },
      state: {
        valueMissing: "Selecione uma opção de estado.",
      },
      employees: {
        valueMissing: "Selecione a quantidade de funcionários da empresa.",
      },
      privacy: {
        valueMissing: "Marque o campo para continuar.",
      }
    };

    this.formElement = document.querySelector(formSelector);
    this.fields = this.formElement.querySelectorAll("input, select");
    this.disableDefaultError();
    this.enabledPhoneMask();
    this.initFields();
    this.initSubmit();
  }

  initSubmit() {
    const form = this.formElement;

    form.querySelector("[type='submit']").addEventListener("click", () => {
      this.fields.forEach((field) => {
        if (field.hasAttribute("required") || field.value.trim().length > 0) {
          this.checkField(field);
        }
      });
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const loader = form.querySelector("[data-loader]");
      const formData = new FormData(form);
      const submitButton = form.querySelector("[type='submit']");
      
      // Google UTM Params
      const param = new URLSearchParams(window.location.search);
      param.forEach((value, key) => {
        formData.set(key, value);
      });

      try {
        submitButton.disabled = true;
        loader.classList.add("active");
        const metaApiResponse = await fetch("./php/pixel-submit.php", {
          method: "POST",
          body: formData,
        });

        const rdResponse = await fetch("./php/rd-submit.php", {
          method: "POST",
          body: formData,
        });

        const result = await rdResponse.json();

        if (result.erro) {

        } else {
          const url = "./obrigado";
          this.formElement.reset();
          window.open(url, "_blank");
        }
      } catch (error) {
        console.log(error);
      } finally {
        loader.classList.remove("active");
        submitButton.disabled = false;
      }
    });
  }


  disableDefaultError() {
    this.fields.forEach((field) =>
      field.addEventListener("invalid", (e) => e.preventDefault())
    );
  }

  initFields() {
    this.fields.forEach((field) => {
      const checkFunc = debounce(() => {
        this.checkField(field);
      }, 200);

      if (field.tagName === "INPUT" || field.tagName === "TEXTAREA") {
        field.addEventListener("keyup", (e) => {
          e.preventDefault();
          checkFunc();
        });
      } else if (field.tagName === "SELECT") {
        field.addEventListener("change", (e) => {
          e.preventDefault();
          checkFunc();
        });
      } else if (field.type === "checkbox") {
        field.addEventListener("click", (e) => {
          e.preventDefault();
          checkFunc();
        });
      }
    });
  }

  enabledPhoneMask() {
    this.formElement.querySelectorAll("[type='tel']").forEach((tel) => {
      tel.addEventListener("input", (e) => {
        let formattedNumber = e.target.value.replace(/\D/g, "");

        if (formattedNumber.length > 13) {
          formattedNumber = formattedNumber.slice(0, 13);
        }

        if (formattedNumber.length > 2) {
          const ddi = formattedNumber.slice(0, 2);
          const restOfNumber = formattedNumber.slice(2);

          let formatted = restOfNumber.replace(/^(\d{2})(\d)/g, "($1) $2");
          formatted = formatted.replace(/(\d)(\d{4})$/, "$1-$2");

          formattedNumber = `+${ddi} ${formatted}`;
        }

        e.target.value = formattedNumber;
      });
    });
  }

  checkField(field) {
    let msg;
    field.setCustomValidity("");
    if (field.name == "fullName") {
      validateCompleteName(field, 2, 2);
    } else if (field.name == "phone") {
      validatePhone(field);
    }
    this.errorTypes.forEach((erro) => {
      if (field.validity[erro]) {
        msg = this.errorMessages[field.name][erro];
        if (erro === "customError") msg = field.validationMessage;
      }
    });

    const inputValidator = field.checkValidity();
    const messageBox = field.parentElement.querySelector("[data-error]");

    if (!inputValidator && !field.disabled) {
      messageBox.innerText = msg;
      messageBox.classList.add("active");
      field.classList.add("error");
    } else {
      messageBox.innerText = "";
      messageBox.classList.remove("active");
      field.classList.remove("error");
    }
  }
}